var map = {
	"./chromealive/Index.vue": [
		2156,
		156
	],
	"./cloud/Index.vue": [
		4448,
		448
	],
	"./datastore/Index.vue": [
		7521,
		521
	],
	"./hero/Index.vue": [
		6293,
		293
	],
	"./stream/Index.vue": [
		8705,
		705
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1537;
module.exports = webpackAsyncContext;